module.exports = __webpack_public_path__ + "img/bg-form-visual.5b3aede1.png";